import { ar } from './ar';
import { en } from './en';
import { es } from './es';
import { de } from './de';
import { zh } from './zh';
import { ja } from './ja';
import { he } from './he';
import { dashboardTranslations } from './dashboard';

const baseTranslations = { ar, en, es, de, zh, ja, he };

// Merge dashboard namespace into each language so callers can use t('dashboard.xyz')
export const translations = Object.fromEntries(
  Object.entries(baseTranslations).map(([code, dict]) => [
    code,
    { ...dict, dashboard: dashboardTranslations[code] || dashboardTranslations.en },
  ])
);

// RTL languages
export const rtlLanguages = ['ar', 'he'];

// Get direction based on language
export const getDirection = (lang) => {
  return rtlLanguages.includes(lang) ? 'rtl' : 'ltr';
};

// Language display names
export const languageNames = {
  ar: 'العربية',
  en: 'English',
  es: 'Español',
  de: 'Deutsch',
  zh: '中文',
  ja: '日本語',
  he: 'עברית',
};

// Language flags (emoji)
export const languageFlags = {
  ar: '🇸🇦',
  en: '🇺🇸',
  es: '🇪🇸',
  de: '🇩🇪',
  zh: '🇨🇳',
  ja: '🇯🇵',
  he: '🇮🇱',
};

export default translations;
